import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { Observable } from 'rxjs';
import { InspectionModelService, MachineFamillyService } from '../../services/index';
import { Inspection } from '../../models/index';
import { BaseModalPageComponent } from '../../../base-modal.component';

@Component({
    selector: 'import-point-index-page',
    templateUrl: './index.component.html',
    standalone: false
})
export class ImportPointIndexPageComponent extends BaseModalPageComponent implements OnInit {
  inspections: Inspection[];
  inspectionId: string;
  sectionId: string;
  folderId: string;
  selectedInspection: Inspection;
  errorMessage: string;
  navigationRoute: string;

  public loading: Boolean = true;

  constructor(
    public inspectionModelService: InspectionModelService,
    private activatedRoute: ActivatedRoute,
    private machineFamillyService: MachineFamillyService,
    private router: Router,
    location: Location
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.navigationRoute = this.router.url.includes('inspections') ? this.inspectionsRoute : this.templatesRoute;
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['targetId'];
      if (id == null) this.router.navigate([this.navigationRoute]);

      this.inspectionId = id;

      const sectionId = params['sectionId'];
      if (sectionId == null) this.router.navigate([this.navigationRoute, this.inspectionId]);

      this.sectionId = sectionId;

      this.folderId = params['folderId'];

      this.initData();
    });
  }

  selectInspection(inspection: Inspection): void {
    this.selectedInspection = inspection;
  }

  openInspection(): void {
    if (this.folderId) {
      this.router.navigate([
        this.navigationRoute,
        this.inspectionId,
        'sections',
        this.sectionId,
        'folders',
        this.folderId,
        'addpoint',
        this.selectedInspection.id
      ]);
    } else {
      this.router.navigate([
        this.navigationRoute,
        this.inspectionId,
        'sections',
        this.sectionId,
        'addpoint',
        this.selectedInspection.id
      ]);
    }
  }

  cancel() {
    this.goToBack();
  }

  initData(): void {
    this.machineFamillyService.getCurrentScopeProductLines().subscribe((pr) => {
      const productLines = pr.map((p) => p.id);
      // Inspection context: published models only — prevents inspectors from importing from
      // in-progress draft templates. Template context: all models — admins need drafts too.
      const models$: Observable<Inspection[]> = this.isInspectionContext()
        ? this.inspectionModelService.getPublishedModels()
        : this.inspectionModelService.getModels();
      models$.subscribe((data) => {
        this.inspections = data.filter((d) => d.categories.some((c) => productLines.includes(c.ProductLineId)));
        this.loading = false;
      });
    });
  }

  private isInspectionContext(): boolean {
    return this.navigationRoute === this.inspectionsRoute;
  }
}
